// src/components/profiles/GuestUser/components/moments/GuestMomentEmptyState.tsx

"use client";

import React from "react";
import { BringToFront } from "lucide-react";
import { Button } from "../../../../common";

import "./GuestMomentEmptyState.css";

interface Props {
  onCreate?: () => void;
}

const GuestMomentEmptyState: React.FC<Props> = ({ onCreate }) => {
  return (
    <div className="guest-moment-empty">
      <div className="guest-moment-empty__icon">
        <BringToFront size={48} />
      </div>

      <h4 className="guest-moment-empty__title">
        Your Moments can start with everyday beauty
      </h4>

      <p className="guest-moment-empty__text">
        Share snapshots from life, small reflections, or visual highlights that
        matter to you.
      </p>

      {onCreate && (
        <Button variant="primary" size="md" onClick={onCreate}>
          <span className="btn-content">
            <span>Create your first Moment</span>
          </span>
        </Button>
      )}
    </div>
  );
};

export default GuestMomentEmptyState;